import Colors from '../../styles/Colors';

const LabeledSelectStyles = () => ({
  basicBackground: {
    backgroundColor: Colors.trueWhite,
  },
});

export default LabeledSelectStyles;
